<div class="row accepted-cash" *ngIf="acceptedCash.length > 0">
  <div class="col-lg-12">
    <span *ngIf="showAcceptedCashLabel" class="accepted-cash-label">{{ text | translate }}:</span>
    <div [attr.class]="cssClass" *ngFor="let x of acceptedCash">
      <denomination [money]="x" [cashType]="cashType" (click)="denominationClick(x)"></denomination>
    </div>
  </div>
</div>
